export enum GeographicalLocation {
    CITY = 'city',
    COUNTRY = 'country'
}